import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class TabCriteria extends BasicCriteria {
owner: string;
visionCode: string;
}

